"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutFormulaTranslations = void 0;
const pt_br_1 = require("./pt_br");
exports.OutFormulaTranslations = {
    pt_br: {
        formulas: pt_br_1.formulas,
        global: pt_br_1.global,
    },
};
